import { useContactManagementTranslation, useUserState } from '../../../../../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LogoutIcon from '@mui/icons-material/Logout';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Button, Divider, IconButton } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { resolveStatusValues } from '../utils/resolveStatusValues';
export const AccountMembershipActions = (props) => {
    const { t } = useContactManagementTranslation();
    return (React.createElement(Box, { sx: { display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'flex-end' }, "data-test": 'membership-actions' },
        props.canManageMembership ? (React.createElement(QuickActionsAdmin, Object.assign({}, props))) : (props.status &&
            !['rejected', 'withdrawn'].includes(props.status) && (React.createElement(QuickActionsUser, { role: props.role, organizationId: props.organizationId, organizationName: props.organizationName, onUpdateMembership: props.onUpdateMembership }))),
        React.createElement(IconButton, { "aria-label": t('common.openSlideout'), onClick: () => props.onOpenSlideout(props.organizationId) },
            React.createElement(KeyboardArrowRightIcon, { htmlColor: themeColors.primary.base }))));
};
const QuickActionsAdmin = (props) => {
    const userState = useUserState();
    const { orgRoleMap, orgStatusMap } = useSelector(getSettings);
    const { t } = useContactManagementTranslation();
    const statusValues = resolveStatusValues(userState, props.organizationId, orgStatusMap);
    const roleValues = Object.entries(orgRoleMap).map(([value, { label }]) => ({ value, label }));
    const disableRole = props.status ? !orgStatusMap[props.status].requireOrgRole : true;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { sx: { py: 1, px: 2 }, variant: 'text', onClick: () => showFormDialog({
                title: t('panels.accounts.membership.dialog.editMembership.title'),
                submitLabel: t('common.save'),
                data: {
                    orgStatus: props.status,
                    orgRole: props.role,
                },
                config: {
                    type: 'form',
                    children: [
                        {
                            type: 'form.select',
                            key: 'orgStatus',
                            label: t('panels.accounts.membership.dialog.editMembership.membershipStatus'),
                            values: statusValues,
                            validate: {
                                required: true,
                            },
                            event: {
                                onChange: (value, handler) => {
                                    var _a;
                                    const roleHandler = handler.up().down('orgRole');
                                    if (roleHandler) {
                                        if (!orgStatusMap[value].requireOrgRole) {
                                            roleHandler.setDisabled(true);
                                            roleHandler.setRequired(false);
                                            roleHandler.setData(undefined);
                                        }
                                        else {
                                            const [defaultRole] = (_a = Object.entries(orgRoleMap).find(([, role]) => !!role.default)) !== null && _a !== void 0 ? _a : [];
                                            roleHandler.setDisabled(false);
                                            roleHandler.setRequired(true);
                                            roleHandler.setData(defaultRole !== null && defaultRole !== void 0 ? defaultRole : 'user');
                                        }
                                        roleHandler.update();
                                    }
                                },
                            },
                        },
                        {
                            type: 'form.select',
                            key: 'orgRole',
                            label: t('panels.accounts.membership.dialog.editMembership.organizationRole'),
                            values: roleValues,
                            disabled: !props.canManageMembership || disableRole,
                            validate: {
                                required: !disableRole,
                            },
                        },
                    ],
                },
                onSubmit: (data) => props.onUpdateMembership({
                    orgId: props.organizationId,
                    role: data.orgRole,
                    status: data.orgStatus,
                    onSubmitSuccess: () => {
                        showAlertSnackbar({
                            message: t('panels.accounts.membership.dialog.editMembership.changesSaved'),
                            type: 'success',
                            autoHideDuration: 2000,
                        });
                    },
                }),
            }) }, t('common.edit')),
        React.createElement(Divider, { orientation: 'vertical', flexItem: true }),
        React.createElement(Button, { sx: { py: 1, px: 2 }, variant: 'text', startIcon: React.createElement(RemoveCircleIcon, null), onClick: () => {
                var _a;
                return showConfirmDialog({
                    title: t('panels.accounts.membership.dialog.remove.title', { orgName: props.organizationName }),
                    confirmLabel: t('common.remove'),
                    content: t('panels.accounts.membership.dialog.remove.confirmRemove', {
                        memberFullName: (_a = props.memberFullName) !== null && _a !== void 0 ? _a : 'account',
                    }),
                    onConfirm: () => props.onUpdateMembership({
                        orgId: props.organizationId,
                        onSubmitSuccess: () => showAlertSnackbar({
                            message: t('panels.accounts.membership.dialog.remove.organizationRemoved'),
                            type: 'success',
                            autoHideDuration: 2000,
                        }),
                    }),
                });
            } }, t('common.remove'))));
};
const QuickActionsUser = (props) => {
    const { t } = useContactManagementTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { sx: { py: 1, px: 2 }, variant: 'text', startIcon: React.createElement(LogoutIcon, null), onClick: () => showConfirmDialog({
                title: t('panels.accounts.membership.dialog.withdraw.title', { organizationName: props.organizationName }),
                confirmLabel: t('panels.accounts.membership.dialog.withdraw.label'),
                content: t('panels.accounts.membership.dialog.withdraw.confirmWithdraw'),
                onConfirm: () => props.onUpdateMembership({
                    orgId: props.organizationId,
                    status: 'withdrawn',
                    onSubmitSuccess: () => showAlertSnackbar({
                        message: t('panels.accounts.membership.dialog.withdraw.successfullyWithdrawn'),
                        type: 'success',
                        autoHideDuration: 2000,
                    }),
                }),
            }) }, t('panels.accounts.membership.dialog.withdraw.label'))));
};
